import { useInfiniteQuery } from '@tanstack/react-query';
import type { AgentApiCompanyChatCommentsIndex } from '@/types/serializers';

export default function useFetchCompanyChatComments(companyId: number) {
  return useInfiniteQuery({
    queryKey: ['companyChatComments', companyId],
    queryFn: async ({ pageParam }): Promise<AgentApiCompanyChatCommentsIndex> => {
      const response = await fetch(
        `/agent/api/companies/${companyId}/company_chat_comments.json?page=${pageParam}`
      );
      if (!response.ok) {
        throw new Error('タイムラインの取得に失敗しました');
      }

      return response.json();
    },
    getNextPageParam: (lastPage) => (lastPage.is_last_page ? undefined : lastPage.next_page),
    initialPageParam: 1,
  });
}
